import { APICore } from './apiCore'

const api = new APICore()

function getTypesContacts (params) {
  const baseUrl = '/types-contacts'
  return api.get(baseUrl, params)
}

function getTypesContact (id) {
  const baseUrl = `/types-contacts/${id}`
  return api.get(baseUrl, {})
}

function addTypesContact (params) {
  const baseUrl = '/types-contacts'
  return api.create(baseUrl, params)
}

function updateTypesContact (params) {
  const baseUrl = '/types-contacts'
  return api.update(baseUrl, params)
}

function deleteTypesContact (params) {
  const baseUrl = '/types-contacts'
  return api.delete(baseUrl, params)
}

export { getTypesContacts, getTypesContact, addTypesContact, updateTypesContact, deleteTypesContact }
